export const policyMixin = {
  computed: {
    addressOptions() {
      //获取地址code
      console.info(window.addrescode)
      return window.addrescode;
    },
    agreementAllRead() {
      //协议文件是否全部已读
      return this.$store.state.insureDoc.agreementAllRead;
    },
    fileCodeContent() {
      return this.$store.state.occupationCode.fileCodeContent;
    },
    payTypeList() {
      //支付方式
      return this.$store.state.payMethod.payObj;
    },
    checkContent() {
      //检测是否需要上传风险告知函
      return this.$store.state.riskNotify.checkContent;
    }
  },
  methods: {
    countTimes() {},
    eduitSelect(data) {
      //修改被保人
      this.salInsuredList.forEach((e, i) => {
        //更新变更项
        if (i == data.eduitIndex) {
          this.salInsuredList[i] = data;
        }
        if (e.occulevel.toString().indexOf('类') <= -1) {
          e.occulevel = e.occulevel + '类';
        }
      });
      this.riskNumber = this.countTimes(this.salInsuredList);
      this.RiskInfos.premiumBaseDtoList = this.numResult(this.salInsuredList);
      this.resultPremiumSum(this.RiskInfos); //计算保费
    },
    addSelectpre(data) {
      //粘贴被保人
      if (Array.isArray(data)) {
        var datas = data;
        this.salInsuredList.push(...datas);
      } else {
        this.salInsuredList.push(data);
      }
      let cesiData = this.$lodash.cloneDeep(this.salInsuredList);
      this.salInsuredList = this.unique(this.salInsuredList, 'idNumber');
      if (cesiData.length != this.salInsuredList.length) {
        this.$message.warning('受保人有重复，已做删除');
      }
      this.riskNumber = this.countTimes(this.salInsuredList);
      this.RiskInfos.premiumBaseDtoList = this.numResult(this.salInsuredList);
      this.resultPremiumSum(this.RiskInfos); //计算保费
    },
    delSelectpre(data) {
      //批量删除被保人
      this.salInsuredList = data;
      let copyData = JSON.parse(JSON.stringify(this.salInsuredList));
      this.salInsuredList = this.unique(this.salInsuredList, 'idNumber');
      if (copyData.length != this.salInsuredList.length) {
        this.$message.warning('受保人有重复，已做删除');
      }
      this.RiskInfos.premiumBaseDtoList = this.numResult(this.salInsuredList);
      this.riskNumber = this.countTimes(this.salInsuredList);
      if (this.salInsuredList.length) {
        this.resultPremiumSum(this.RiskInfos); //计算保费
      } else {
        this.applicantInfo.totalPremium = 0;
      }
    },
    onChangeyueduBtn(e) {
      //理解并阅读
      this.yueduBtn = e.target.checked;
    },
    fastInsure(needUnderwriting) {
      needUnderwriting = ''
      //立即投保
      if (!this.yueduBtn) {
        this.$message.warning('请确认已充分阅读、理解并同意《保险条款》《投保须知》《责任免除》', 2);
        return;
      }
      if(needUnderwriting !== '1') {
        this.showPaySure = true;
        return
      }
      this.$store.commit('setLoading', {
        show: true,
        text: '核保中，请稍后...',
      });
      this.$api.payBeforeUnderwriting(this.$route.query.policyId)
        .then(res => {
          if (res.data.returnCode !== "00") {
            return;
          }
          this.showPaySure = true;
        })
        .finally(() => {
          this.$store.commit('setLoading', { show: false });
        });
    },

    numResult(data) {
      //统计各个类别被报人人数
      var d = [];
      var b = {
        1: 0,
        2: 0,
        3: 0,
        4: 0,
        5: 0
      };
      data.forEach(e => {
        let levelF = Number(e.occulevel.toString().slice(0, 1));
        if (b[levelF] !== undefined) {
          b[levelF] += 1;
        }
      });
      for (const key in b) {
        var c = {
          occupationKind: '',
          personNum: 0
        };
        c.occupationKind = key;
        c.personNum = b[key];
        d.push(c);
      }
      return d;
    },
    unique(arr, attribute) {
      //提交时 对被保人根据身份证去重
      var new_arr = [];
      var json_arr = [];
      for (var i = 0; i < arr.length; i++) {
        if (new_arr.indexOf(arr[i][attribute]) == -1) {
          //  -1代表没有找到
          new_arr.push(arr[i][attribute]); //如果没有找到就把这个name放到arr里面，以便下次循环时用
          json_arr.push(arr[i]);
        }
      }
      return json_arr;
    },
    async blurCompanyName(type, noForm) {
      let name = ''
      if(noForm) {
        name = this.name
      } else {
        let data = this.form.getFieldsValue().applicantInfo||this.applicantInfo;
        name = data.name;
        this.applicantInfo.name = data.name;
      }
      var reg = new RegExp('[\u4e00-\u9fa5]+', 'g'); //验证如果不是只包含汉字 返回
      if (!reg.test(name)) {
        return;
      }
      if(!type) {
        return
      }
      let code = await this.queryCompanyListByName(name, type) || ''
      if(noForm) {
        this.idNumber = code
      } else {
        this.form.setFieldsValue({
          applicantInfo: {
            idNumber: code
          }
        })
        this.applicantInfo.idNumber = code
      }
    },
    /**
     * 当证件类型=营业执照或统一社会信用代码, 第三方获取
     * @param {*} value 公司名
     */
    async queryCompanyListByName(value, type) {
      //查询目标公司开户信息
      let data = {
        keyword: value
      };
      let companyId = ''
      await this.$api.enterpriseSearchByName(data).then(r => {
        if (r.data.content.items) {
          const companyList = r.data.content.items;
          companyList.some(item => {
            if (item.entname === value) {
              companyId = item.id
              return true
            }
            return false
          })
        }
      });
      if(companyId) {
        return await this.queryCompanyCode(companyId, type);
      }
      return false
    },
    // 根据公司id查询公司信息 type 1 社会信用代码 2 组织机构代码
    async queryCompanyCode(companyId, type) {
      let data = {
        id: companyId
      };
      let companyCode = '';
      await this.$api.queryCompanyInfoById(data).then(r => {
        // "ORGCODE": "312375725", //组织机构编码
        // "OPLOC": "上海市崇明区横沙乡富民支路58号3419室（上海横泰经济开发区）", //公司地址
        // "GONGSH": "310105000463337", //工商注册号
        // "code": "200",
        // "TAXNUMBER": "91310230312375725G", //纳税人识别号（2）
        // "UNCID": "91310230312375725G", //纳税人识别号
        // "HASUNIFY": true,
        // "ENTNAME": "上海南燕信息技术有限公司", //公司名称
        // "message": "success"
        if (r.data.returnCode == '00' && r.data.content) {
          let data = r.data.content;
          companyCode = type === 2 ? data.ORGCODE : (data.UNCID || data.TAXNUMBER);
        }
      });
      return companyCode;
    }
  },
  mounted() {
    //获取url通用参数参数
    const { u, p, planCode } = this.$route.query;
    this.creator = u;
    this.productCode = p;
    this.plan = planCode;
    this.userParams = {
      //保存链接数据
      userId: u,
      productCode: this.productCode
    };
    if (this.$route.query.policyId) {
      //policyId存在则查询保单信息
      this.queryOrderDetails(); //查询保单信息
      this.disabledAll = true;
    } else {
      this.disabledAll = false;
    }
  }
};
